/* TODO: t() */
import React, { Component } from 'react';
import TextInput from './TextInput';

type Props = {
  defaultValue?: number;
  onChange?: (value: number) => void;
};

type State = {
  value: string;
};

class IntegerInput extends Component<Props, State> {
  static defaultProps = {
    defaultValue: 0,
  };

  state: State = {
    value: String(this.props.defaultValue),
  };

  render() {
    let { value } = this.state;
    let { defaultValue } = this.props;
    let placeholderValue = defaultValue ? defaultValue.toString() : '';
    return (
      <TextInput
        placeholder={placeholderValue}
        onBlur={this._onBlur}
        value={value}
        onChangeText={this._onChangeText}
      />
    );
  }

  _onBlur = () => {
    let { value } = this.state;
    let number = Number(value.replace(/,/g, '').trim()) | 0;
    let newValue = String(number);

    this.setState({ value: newValue });

    let { onChange } = this.props;
    onChange && onChange(number);
  };

  _onChangeText = (value: string) => {
    this.setState({ value });
  };
}

export default IntegerInput;
